var React = require('react');

function HudlForwardSlash (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"🟢-About--**-Needs-Review**","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("polygon",{"id":"Rectangle","points":"11.6323676 7.10542736e-14 16 7.10542736e-14 4.6953047 20 0 20","fill":"#FF5000"})));
}

HudlForwardSlash.defaultProps = {"width":"16px","height":"20px","viewBox":"0 0 16 20","version":"1.1"};

module.exports = HudlForwardSlash;

HudlForwardSlash.default = HudlForwardSlash;
